module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    key: _vm.componentKey,
    staticClass: "detail-card"
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Shop Orders")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.sellpoint_pending_orders).length !== 0)) ? _c('div', {
    staticClass: "detail-card"
  }, [_vm._m(1), _vm._v(" "), (!_vm.viewPendingPayOrders) ? _c('div', {
    staticClass: "card card-flat-pad sp-app-default-background-color",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.viewPendingPayOrders = true;
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "95%"
    }
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(" You have " + _vm._s((_vm.sellpoint_pending_orders).length) + " Pending Payments")])])])]) : _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v(_vm._s((_vm.sellpoint_pending_orders).length) + " Pending Payment(s)\r\n                "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.viewPendingPayOrders = false;
      }
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {}, _vm._l((_vm.sellpoint_pending_orders), function(spo, spodex) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "left",
        "width": "55%"
      }
    }, [_c('b', [_vm._v(_vm._s(spo.payment_data.payment_payer_name))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%"
      }
    }, [_vm._v("  ₦" + _vm._s(spo.payment_data.payment_amount))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', [_vm._v("\r\n                      __"), _c('br'), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%",
        "font-size": "13px"
      }
    }, [_vm._v("  ₦" + _vm._s(spo.payment_data.payment_pending_amount_to_pay))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), (_vm.sellpoint.business_agent == 0) ? _c('div', [(((spo.payment_data.payment_set_to_receive_from == 1) && (spo.payment_data.payment_amount_to_pay !== 0))) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(((_vm.set_order_pending_payment_data == 'ord' + spodex) && (Object.keys(_vm.set_pending_payment_data).length !== 0))) ? _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.set_pending_payment_data
      }
    })], 1) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setPendingOrdersPayment(spo, spodex)
        }
      }
    }, [_vm._v("Make Payment")])])]) : _vm._e(), _vm._v(" "), (spo.payment_data.payment_set_to_receive_from == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(spo.payment_data.payment_settled_by_agent != 1) ? _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by Agent")]) : _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment has been sent to you from Agent")]), _vm._v(" "), (spo.payment_data.payment_settled_by_agent == 1) ? _c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.updateOrdersGeneralDetails(spo)
        }
      }
    }, [_vm._v("Confirm Payment")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('div', [(spo.payment_data.payment_set_to_receive_from == 1) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by Seller")])]) : _vm._e(), _vm._v(" "), (spo.payment_data.payment_set_to_receive_from == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by you")]), _vm._v(" "), (((_vm.set_order_pending_payment_data == 'ord' + spodex) && (Object.keys(_vm.set_pending_payment_data).length !== 0))) ? _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.set_pending_payment_data
      }
    })], 1) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setPendingOrdersPayment(spo, spodex)
        }
      }
    }, [_vm._v("Make Payment")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['SPO' + spodex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(4, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('SPO' + spodex)
        }
      }
    }, [_vm._m(5, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SPO' + spodex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [(_vm.viewPendingPayOrder) ? _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('hr'), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "28px",
        "font-weight": "bolder",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
      style: ({
        color: _vm.order.order_status_color
      })
    }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
      staticClass: "table table-striped",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "20%",
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                      " + _vm._s(item.order_item_no) + "\r\n                                    ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "50%"
        }
      }, [_vm._v("\r\n                                      " + _vm._s(item.product_name) + "\r\n                                      "), _c('br'), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
    })], 2)]), _vm._v(" "), _c('div', {}, [_vm._v("\r\n                                " + _vm._s(_vm.order_commissions_stl) + "\r\n                              ")])])]) : _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bolder",
        "font-size": "18px"
      }
    }, [_vm._v(" . . .")]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_service))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_ref))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Orders Made")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please confirm payment to view orders")])])])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-card"
  }, [_vm._m(9), _vm._v(" "), (_vm.sellpoint_orders && (Object.keys(_vm.sellpoint_orders).length === 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No orders yet")]) : _vm._e(), _vm._v(" "), (_vm.viewOrder) ? _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('order-request', {
    attrs: {
      "order_data": _vm.order
    }
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.order_item_no) + "\r\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.product_name) + "\r\n                      "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)]), _vm._v(" "), _c('div', {}, [_vm._m(10), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Earner")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_commissions_stl), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "11px"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.service_commission_amount.toFixed(2)) + "\r\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.service_commission_earner_name) + "\r\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.service_commission_module_name) + "\r\n                      "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.service_commission_module_image_url,
        "height": "50",
        "width": "50"
      }
    })])])])
  })], 2)])]), _vm._v(" "), (_vm.order.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order.order_status_id == 2) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Mark order as delivered")])]) : _vm._e()]) : _vm._e()])]) : _c('div', _vm._l((_vm.sellpoint_orders), function(order, odex) {
    return _c('div', {
      key: _vm.orderComponentKey,
      staticClass: "card card-flat-pad card-striped"
    }, [(order.order_status_id != 20) ? _c('div', [(_vm.sellpoint.business_agent == 1) ? _c('a', {
      staticStyle: {
        "float": "right",
        "color": "inherit",
        "font-weight": "bolder",
        "text-decoration": "underline"
      },
      attrs: {
        "href": '/' + order.order_business_username
      }
    }, [_vm._v(_vm._s(order.order_business))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('orders', order)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (order.order_status_id == 20) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_c('b', [_vm._v("Confirm order")])]) : _vm._e(), _vm._v(" "), (order.order_status_id == 2) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_vm._v("Mark order as delivered")]) : _vm._e(), _vm._v(" "), (order.order_status_id == 18) ? _c('p', {
      staticStyle: {
        "color": "#337ab7"
      }
    }, [_vm._v("Delivered")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((order.order_items), function(item, idex) {
      return (idex < 2) ? _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "35",
          "width": "35"
        }
      })]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Pending Order Payment Confirmation\r\n                "), (_vm.sellpoint.business_agent == 0) ? _c('span', [_c('br'), _c('b', [_vm._v("Please clear payments")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Pending Order-Payments Confirmation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-bell",
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "left",
      "width": "55%",
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Amount to pay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment Ref")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Commissions earned in this Order")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8199d366"}!./src/pages/Manage/Orders/template.html
// module id = 572
// module chunks = 0